<template>
  <!-- 訂單改時間視窗 -->
  <UiModal v-model="isModalShow" :forcing="true" :header-title="headerTitle" :hide-overlay="false" @close-icon-event="resetDateAndTime">
    <div v-if="step === RescheduleModalStep.Remind" class="wd-px-5 wd-pb-5 wd-pt-3 wd-whitespace-pre-line">{{ hintText }}</div>

    <div v-if="step === RescheduleModalStep.Reschedule" class="wd-pb-4 wd-pt-1">
      <div class="wd-pb-3 wd-px-5">
        <p class="mb-1 enjoyTime__prefix">{{ $t('origin_booking_time') }}</p>
        <div class="wd-mb-1 wd-flex wd-justify-between wd-items-center">
          <span>{{ originEnjoyTimeRange }}</span>
          <div v-if="showHeadcountSwiper" class="wd-min-w-[32px] wd-text-sm wd-flex wd-justify-between wd-items-center">
            <FunnowIcon activeClass="wd-w-16px" image-path="member-icon.svg" />
            <span>
              {{ order.occupation_count || 0 }}
            </span>
          </div>
        </div>
        <div class="wd-w-6">
          <FunnowIcon :image-path="'arrowline__down.svg'" />
        </div>
        <p class="my-1 enjoyTime__prefix">{{ $t('new_booking_time') }}</p>
        <div class="wd-flex wd-justify-between wd-items-center">
          <span>{{ enjoyTimeRangeText }}</span>
          <div v-if="showHeadcountSwiper" class="wd-min-w-[32px] wd-text-sm wd-flex wd-justify-between wd-items-center">
            <FunnowIcon activeClass="wd-w-16px" image-path="member-icon.svg" />
            <span>
              {{ occupationCount || '-' }}
            </span>
          </div>
        </div>
      </div>

      <div class="divider wd-bg-gray20" />

      <template v-if="showHeadcountSwiper && headcountItems">
        <div class="wd-px-5 wd-pb-3">
          <!-- v-slide-group-item value 給 0，第一個選項會是 isSelected 的，不符合預期 -->
          <HeadCountSwiper
            v-model="occupationCount"
            hide-group
            :head-count-items="headcountItems"
            @update:model-value="getReschedulableInfoByHeadcount"
          >
            <template #summary>
              <div class="wd-text-red50 wd-text-sm wd-mt-2">
                <span>{{ headcountErrorMessage }}</span>
              </div>
            </template>
          </HeadCountSwiper>
        </div>
        <div class="divider wd-bg-gray20" />
      </template>

      <div class="wd-px-5 wd-relative">
        <v-overlay :model-value="isFetchingRescheduleInfo" class="wd-items-center wd-justify-center" contained scrim="#fff">
          <div>
            <Loading color="orange50" />
          </div>
        </v-overlay>
        <DateTimeModule
          v-if="!showHeadcountSwiper || Object.keys(dateTimePickerOptions.arrivalTimes).length"
          container-ref="#uiModalSheet"
          :arrival-times="dateTimePickerOptions.arrivalTimes"
          :time-mode="dateTimePickerOptions.timeMode"
          :checkout-time="formattedCheckOutTime"
          :start-day="dateTimePickerOptions.startDay"
          :default-start-date="startDateTime"
          :is-time-swiper="false"
          :show-time-discount-hint="false"
          @change="handlePickerChange"
        />
        <div v-else>
          <p class="wd-text-gray80 wd-text-xs">{{ $t('select_date') }}</p>
          <div
            class="wd-text-gray80 wd-text-base wd-whitespace-pre-wrap wd-text-center wd-leading-6 wd-h-200px wd-flex wd-items-center wd-justify-center"
          >
            <p v-if="headcountErrorMessage">{{ $t('modify_unpaid_booking_hint_select_pax') }}</p>
            <p v-else>
              {{ $t('no_resource_msg_title') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="step === RescheduleModalStep.Seats" class="wd-pb-4 wd-pt-1">
      <div class="wd-px-5 wd-pb-3">
        <div>
          <span class="wd-text-xs wd-text-red50">{{ $t('payment_preferred_seat_reselect') }}</span>
        </div>
        <div class="wd-pt-3"><RemarkFormField :remark="seatsRemark" @option-change="handleSeatChange" /></div>
      </div>
    </div>

    <div v-if="step === RescheduleModalStep.Reconfirm" class="wd-px-5 wd-pb-5 wd-pt-3">
      <p class="mb-1 enjoyTime__prefix">{{ $t('origin_booking_time') }}</p>
      <div class="wd-mb-1 wd-flex wd-justify-between wd-items-center">
        <span>{{ originEnjoyTimeRange }}</span>
        <div v-if="showHeadcountSwiper" class="wd-text-sm wd-flex wd-justify-between wd-items-center">
          <FunnowIcon activeClass="wd-w-16px" image-path="member-icon.svg" />
          <span>
            {{ order.occupation_count || 0 }}
          </span>
        </div>
      </div>
      <FunnowIcon max-width="24" :image-path="'arrowline__down.svg'" />
      <p class="my-1 enjoyTime__prefix">{{ $t('new_booking_time') }}</p>
      <div class="wd-flex wd-justify-between wd-items-center">
        <i18n-t keypath="booking_time_period_format" tag="span">
          <template #starttime>
            <span :class="{ 'wd-text-orange50': !isSameBookingTime }">{{ enjoyTimeRange.startTime }}</span>
          </template>
          <template #endtine>
            <span :class="{ 'wd-text-orange50': !isSameBookingTime }">{{ enjoyTimeRange.endTime }}</span>
          </template>
        </i18n-t>
        <div
          v-if="showHeadcountSwiper"
          class="wd-text-sm wd-flex wd-justify-between wd-items-center"
          :class="{ 'wd-text-orange50': !isSameHeadcount }"
        >
          <FunnowIcon activeClass="wd-w-16px" image-path="member-icon.svg" />
          <span>
            {{ occupationCount || 0 }}
          </span>
        </div>
      </div>
    </div>

    <div v-if="errorUiInformation.isError" class="wd-px-5 wd-pb-5 wd-pt-3">
      {{ errorUiInformation.text }}
    </div>

    <template #buttons>
      <div v-if="step === RescheduleModalStep.Remind" class="event-buttons-group">
        <!-- 取消 -->
        <v-btn
          :class="[reschedulable ? 'cancel-btn mr-4' : 'confirm-btn white--text']"
          :color="reschedulable ? 'gray20' : 'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="cancelRemindStep"
        >
          {{ reschedulable ? $t('all_cancel') : $t('all_ok') }}
        </v-btn>

        <!-- 確認更改 -->
        <v-btn
          v-show="reschedulable"
          type="submit"
          class="confirm-btn text-white"
          color="orange50"
          :min-width="66"
          :min-height="40"
          variant="flat"
          :loading="isFetchingRescheduleInfo"
          @click="confirmRemindStep"
        >
          {{ $t('confirm_change') }}
        </v-btn>
      </div>

      <div v-if="step === RescheduleModalStep.Reschedule" class="event-buttons-group">
        <!-- 確認更改 -->
        <v-btn
          class="confirm-btn text-white"
          :class="{ disabled: disableRescheduleConfirmButton }"
          :color="disableRescheduleConfirmButton ? 'orange30' : 'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          :loading="isFetchingRescheduleInfo"
          @click="confirmRescheduleStep"
        >
          {{ $t('confirm_change') }}
        </v-btn>
      </div>

      <div v-if="step === RescheduleModalStep.Seats" class="event-buttons-group">
        <!-- 確認更改 -->
        <v-btn
          class="confirm-btn text-white"
          :class="{ disabled: disableSeatChangeConfirmButton }"
          :color="disableSeatChangeConfirmButton ? 'orange30' : 'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="confirmSeatChangeStep"
        >
          {{ $t('confirm_change') }}
        </v-btn>
      </div>

      <div v-if="step === RescheduleModalStep.Reconfirm" class="event-buttons-group">
        <!-- 修改時間 -->
        <v-btn class="cancel-btn mr-4" :min-width="66" :min-height="40" variant="flat" color="gray30 wd-text-black50" @click="cancelReconfirmStep">
          {{ $t('modify_order_examination_reverse_button') }}
        </v-btn>
        <!-- 確認更改 -->
        <v-btn
          type="submit"
          class="confirm-btn text-white"
          :color="'orange50'"
          :loading="isUpdatingReschedule"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="confirmReconfirmStep"
        >
          {{ $t('confirm_change') }}
        </v-btn>
      </div>

      <div v-if="errorUiInformation.isError" class="event-buttons-group">
        <v-btn
          :key="errorUiInformation.buttonText"
          type="submit"
          class="confirm-btn text-white"
          :color="'orange50'"
          :min-width="66"
          :min-height="40"
          variant="flat"
          @click="confirmErrorStep"
        >
          {{ errorUiInformation.buttonText }}
        </v-btn>
      </div>
    </template>
  </UiModal>
</template>

<script setup lang="ts">
import { isEmpty as _isEmpty } from 'lodash-es'
import UiModal from '@/components/dialog/ui-modal.vue'
import DateTimeModule from '@/components/DateTimeModule.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import HeadCountSwiper from '@/components/swiper/head-count-swiper.vue'
import Loading from '@/components/icons/loading.vue'
import RemarkFormField from '@/components/RemarkFormField.vue'

import { useOrderFlags } from '@/composition/useOrder'

import { getReschedule, updateReschedule } from '@/service/order'
import { RescheduleModalStep, type OrderDetail } from '@/view-models/order'
import { TimeMode } from '@/view-models/common'
import type { OrderSeatsParams } from '@/view-models/remark'
import { getProductSeats } from '@/service/product'

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss'

type Props = {
  modelValue: boolean
  order: OrderDetail
  token: string
  reschedulable: boolean
  hintText: string
}

defineOptions({
  name: 'OrderRescheduleModal',
})

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  order: () => ({} as OrderDetail),
  token: '',
  reschedulable: false,
  hintText: '',
})

const emit = defineEmits(['update:modelValue'])

const nuxtApp = useNuxtApp()
const { $dayjs, $store: store } = nuxtApp
const i18n = useI18n()
const { order } = toRefs(props)
const { hasSeat } = useOrderFlags(order)

const startDateTime = ref('')
const timezone = ref('')
const startDateTimeText = ref('')
const endDateTimeText = ref('')

const isModalShow = ref(props.modelValue)
const step = ref<RescheduleModalStep>(RescheduleModalStep.Remind)
const updatedRescheduleErrorMessage = ref('')
const isUpdatingReschedule = ref(false)

const isFetchingRescheduleInfo = ref(false)
const showHeadcountSwiper = ref(false)
const headcountItems = ref<{ value: number }[] | null>(null)
const headcountErrorMessage = ref('')
const occupationCount = ref<number | null>(null)
const seatId = ref<number | null>(null)
const dateTimePickerOptions = ref({
  startDay: '',
  bestOffPeak: {},
  timeMode: TimeMode.SevenDays,
  arrivalTimes: {},
  symbol: '',
  symbolCode: '',
  minPrice: 0,
  rrp: 0,
  remainMode: 0,
  remainReference: 0,
})

const { isOrderHeadcountChangeable } = useOrderFlags(order)
const formattedCheckOutTime = computed(() => {
  return props.order.checkout_time ? $dayjs(props.order.checkout_time).format('HH:mm:ss') : props.order.checkout_time
})

function sortSellDates(sellDates: Record<string, any>) {
  return Object.keys(sellDates)
    .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
    .reduce((formattedObj, date) => {
      formattedObj[date] = sellDates[date]
      return formattedObj
    }, {} as Record<string, any>)
}

function updateDateTimePickerOptions({ startDay, timeMode, sellDates }: { startDay?: string; timeMode: number; sellDates: Record<string, any> }) {
  const formattedStartDay = startDay ?? Object.keys(sellDates)[0] ?? ''
  const isSevenDays = timeMode === TimeMode.SevenDays
  dateTimePickerOptions.value = isSevenDays
    ? {
        ...dateTimePickerOptions.value,
        startDay: formattedStartDay,
        timeMode,
        arrivalTimes: sellDates,
      }
    : {
        ...dateTimePickerOptions.value,
        timeMode,
        arrivalTimes: sellDates,
      }
}

function handlePickerChange({ startDate, startTime, endDate }: { startDate: string; startTime: string; endDate: string }) {
  if (!startDate || !startTime) {
    return
  }
  const { duration_text, duration } = props.order

  if (duration_text) {
    endDateTimeText.value = duration_text
  } else if (endDate && formattedCheckOutTime.value) {
    endDateTimeText.value = $dayjs(`${endDate} ${formattedCheckOutTime.value}`).format(DATE_FORMAT)
  } else if (duration >= 0) {
    endDateTimeText.value = $dayjs(`${startDate} ${startTime}`).add(duration, 'minute').format(DATE_FORMAT)
  }

  startDateTimeText.value = $dayjs(`${startDate} ${startTime}`).format(DATE_FORMAT)
  startDateTime.value = $dayjs.tz(`${startDate} ${startTime}`, timezone.value).utc().format()
}

const headerTitle = computed(() => {
  const titleMap = {
    [RescheduleModalStep.Remind]: i18n.t('modify_unpaid_booking_title'),
    [RescheduleModalStep.Seats]: i18n.t('modify_unpaid_booking_title'),
    [RescheduleModalStep.Reschedule]: i18n.t('modify_unpaid_booking_title'),
    [RescheduleModalStep.Reconfirm]: i18n.t('confirm_change'),
    [RescheduleModalStep.ErrorGetRescheduleError]: i18n.t('ChangeTimeAlert_noAvailableTime_title'),
    [RescheduleModalStep.ErrorUpdateRescheduleError]: i18n.t('cannot_modify_booking_title'),
  }

  return titleMap[step.value] || i18n.t('modify_unpaid_booking_title')
})

const errorUiInformation = computed(() => {
  switch (step.value) {
    case RescheduleModalStep.ErrorGetRescheduleError:
      return {
        isError: true,
        text: i18n.t('ChangeTimeAlert_noAvailableTime_content'),
        buttonText: i18n.t('ChangeTimeAlert_noAvailableTime_confirmButton'),
      }
    case RescheduleModalStep.ErrorUpdateRescheduleError: {
      const defaultErrorMessage = hasSeat.value
        ? i18n.t('ChangeTimeAlert_rescheduleFail_with_seat_content')
        : i18n.t('ChangeTimeAlert_rescheduleFail_content')
      return {
        isError: true,
        text: updatedRescheduleErrorMessage.value || defaultErrorMessage,
        buttonText: i18n.t('ChangeTimeAlert_noAvailableTime_confirmButton'),
      }
    }
    default:
      return {
        isError: false,
        text: '',
        buttonText: '',
      }
  }
})

const originEnjoyTimeRange = computed(() => {
  const startTime = timeUtil.formatDateTime(props.order.booking_time)
  const endTime = timeUtil.formatDateTime(props.order.end_time_text) || props.order.end_time_text
  return i18n.t('booking_time_period_format', { starttime: startTime, endtine: endTime })
})

const isSameBookingTime = computed(() => {
  return timeUtil.isSame(startDateTime.value, props.order.booking_time)
})

const isSameHeadcount = computed(() => {
  return Number(props.order.occupation_count) === Number(occupationCount.value)
})

const enjoyTimeRange = computed(() => {
  const fallbackText = i18n.t('all_unselect')
  const startTime = timeUtil.formatDateTime(startDateTimeText.value) || fallbackText
  const endTime = timeUtil.formatDateTime(endDateTimeText.value) || fallbackText
  return {
    startTime,
    endTime,
  }
})

const enjoyTimeRangeText = computed(() => {
  return i18n.t('booking_time_period_format', {
    starttime: enjoyTimeRange.value.startTime,
    endtine: enjoyTimeRange.value.endTime,
  })
})

const disableRescheduleConfirmButton = computed(() => {
  return !startDateTime.value
})

const disableSeatChangeConfirmButton = computed(() => {
  return !seatId.value
})

const user = computed(() => store.getters['authentication/getUser'])
const fromTngMiniProgram = computed(() => store.getters.fromTngMiniProgram)

const hasSeatsBooked = computed(() => {
  return !_isEmpty(props.order.seat)
})

const isNeedSeatChange = computed(() => {
  if (!hasSeatsBooked.value) return false
  return !seats.value?.some(seat => seat.seat_id === props.order.seat.id)
})

const { state: seats, execute: getSeats } = useAsyncState(
  async () => {
    const res = await getProductSeats(nuxtApp.$axios, props.order.product.id, {
      bookingTime: startDateTimeText.value, // 'YYYY-MM-DD HH:mm:ss'
      headcount: occupationCount.value || 0,
    })
    return res
  },
  [],
  {
    immediate: false,
  }
)

const { getSeatRemark } = useSeatRemark()

const seatsRemark = computed(() => getSeatRemark(seats.value))

function handleSeatChange([_remarkId, selectedSeatId]: [number, number]) {
  seatId.value = selectedSeatId
}

watch(isModalShow, newBoolean => {
  emit('update:modelValue', newBoolean)
})

watch(
  () => props.modelValue,
  newValue => {
    isModalShow.value = newValue
  }
)

function resetUserOrder() {
  if (fromTngMiniProgram.value) {
    location.replace(`/en/tng/1?from=tng&type=tng-order-detail&orderid=${props.order.id}`)
  } else {
    window.location.reload()
  }
}

function confirmRemindStep() {
  initReschedulableInfo()
}

function cancelRemindStep() {
  hideModal()
}

async function confirmRescheduleStep() {
  if (disableRescheduleConfirmButton.value) {
    return
  }
  if (hasSeatsBooked.value) {
    await getSeats()
    if (isNeedSeatChange.value) {
      seatId.value = null
      step.value = RescheduleModalStep.Seats
      return
    }
  }
  step.value = RescheduleModalStep.Reconfirm
}

function confirmSeatChangeStep() {
  if (disableSeatChangeConfirmButton.value) {
    return
  }
  step.value = RescheduleModalStep.Reconfirm
}

function confirmReconfirmStep() {
  updateReschedulableTime()
}

function cancelReconfirmStep() {
  step.value = RescheduleModalStep.Reschedule

  // NOTE: 不使用 updateDateTimePickerOptions 來更新 startDay 是因為其預設行為不會對 30D 的日期做預選 startDay
  // 但返回編輯視窗時，需要保留用戶所選日期

  dateTimePickerOptions.value = {
    ...dateTimePickerOptions.value,
    startDay: startDateTime.value ? $dayjs(startDateTime.value).format('YYYY-MM-DD') : '',
  }
}

function confirmErrorStep() {
  resetDateAndTime()
  hideModal()
}

function resetDateAndTime() {
  step.value = RescheduleModalStep.Remind
  startDateTimeText.value = i18n.t('all_unselect')
  endDateTimeText.value = i18n.t('all_unselect')
  startDateTime.value = ''
  occupationCount.value = null
  headcountErrorMessage.value = ''
  headcountItems.value = null
}

function hideModal() {
  isModalShow.value = false
}

async function initReschedulableInfo() {
  const { id, occupation_count } = props.order
  isFetchingRescheduleInfo.value = true
  try {
    const res = await getReschedule(nuxtApp.$axios, {
      orderId: id,
      token: props.token,
      headcount: isOrderHeadcountChangeable.value ? occupation_count : undefined,
    })
    // 這邊的 headcount_changeable 會去比較方案設定有沒有被修改過，方案被修改過不可以在更改人數
    // True 代表訂單可以修改人數和時間，反之只能修改時間
    const { time_mode, headcount = [], headcount_changeable: newHeadcountChangeable, timezone: newTimezone } = res.data
    const sellDates = sortSellDates(res.data.selldates)

    const hasRescheduleInfo = newHeadcountChangeable ? Array.isArray(headcount) && headcount.length > 0 : !!Object.keys(sellDates).length
    const currentOccupationCount = newHeadcountChangeable ? occupation_count : 0

    if (!hasRescheduleInfo) {
      step.value = RescheduleModalStep.ErrorGetRescheduleError
      return
    }

    showHeadcountSwiper.value = newHeadcountChangeable
    step.value = RescheduleModalStep.Reschedule
    timezone.value = newTimezone
    updateDateTimePickerOptions({ timeMode: time_mode, sellDates })

    occupationCount.value = currentOccupationCount
    headcountItems.value = newHeadcountChangeable ? headcount.map((count: number) => ({ value: count })) : null

    // 當前人數不在可選人數內
    if (newHeadcountChangeable && !headcount.includes(currentOccupationCount)) {
      headcountErrorMessage.value = i18n.t('modify_unpaid_booking_error_insufficient_pax', { pax: currentOccupationCount })
      occupationCount.value = null
    }
  } catch (error) {
    console.error('getReschedule:error', error)
    step.value = RescheduleModalStep.ErrorGetRescheduleError
  } finally {
    isFetchingRescheduleInfo.value = false
  }
}

/**
 * @description 可預訂時間 >= 新選人數，則不變更用戶所選日期。
 *       可預訂時間 <= 新選人數，則清空日曆，讓用戶重新選擇。
 */
function updateCurrentSelectedDateByNewSellDates(newTimeMode: number, newSellDates: Record<string, any>) {
  const formattedSellDates = sortSellDates(newSellDates)
  const selectedStartDate = startDateTime.value ? $dayjs(startDateTime.value).format('YYYY-MM-DD') : ''
  const isSelectedStartDateAvailable = !selectedStartDate || Object.keys(formattedSellDates).includes(selectedStartDate)
  const newStartDay = isSelectedStartDateAvailable ? selectedStartDate : ''

  // 會觸發 handlePickerChange 來重置所選時間
  updateDateTimePickerOptions({ startDay: newStartDay, timeMode: newTimeMode, sellDates: formattedSellDates })
  if (isSelectedStartDateAvailable) {
    return
  }

  startDateTime.value = ''
  startDateTimeText.value = i18n.t('all_unselect')
  endDateTimeText.value = i18n.t('all_unselect')
}

async function getReschedulableInfoByHeadcount(newHeadcount: number | null) {
  newHeadcount = newHeadcount || props.order?.occupation_count || 0
  headcountErrorMessage.value = ''
  isFetchingRescheduleInfo.value = true
  try {
    const {
      data: { time_mode, headcount = [], selldates },
    } = await getReschedule(nuxtApp.$axios, {
      orderId: props.order.id,
      token: props.token,
      headcount: newHeadcount,
    })

    updateCurrentSelectedDateByNewSellDates(time_mode, selldates)
    // 一樣保留人數 swiper 但無法選擇時間
    // 避免切換人數後，人數的 swiper 會隱藏造成使用者困擾
    if (headcount.length) {
      headcountItems.value = headcount.map((count: number) => ({ value: count }))
    }

    if (headcount.length && !headcount.includes(newHeadcount)) {
      headcountErrorMessage.value = i18n.t('modify_unpaid_booking_error_insufficient_pax', { pax: newHeadcount })
    }
  } catch (error) {
    console.error(error)
    step.value = RescheduleModalStep.ErrorGetRescheduleError
  } finally {
    isFetchingRescheduleInfo.value = false
  }
}

async function updateReschedulableTime() {
  const { $axios } = useNuxtApp()
  const seat = seats.value.find(seat => seat.seat_id === seatId.value)
  const seatPayload: OrderSeatsParams =
    isNeedSeatChange.value && !!seatId.value
      ? {
          id: seatId.value,
          name: seat?.seat_name || '',
          lang_for_usen: seat?.lang_for_usen || '',
        }
      : {
          id: props.order.seat?.id,
          name: props.order.seat?.content,
          lang_for_usen: props.order.seat?.lang_for_usen || '',
        }
  const payload = {
    new_booking_time: startDateTime.value,
    uid: user.value?.uid,
    token: props.token,
    ...(showHeadcountSwiper.value ? { headcount: occupationCount.value } : {}),
    ...(hasSeatsBooked.value ? { seat: seatPayload } : {}),
  }
  try {
    isUpdatingReschedule.value = true
    await updateReschedule($axios as any, props.order.id.toString(), payload)
    resetUserOrder()
  } catch (error: any) {
    const { code, message } = error
    console.error('updateReschedule:error', error)

    step.value = RescheduleModalStep.ErrorUpdateRescheduleError
    updatedRescheduleErrorMessage.value = message
  } finally {
    isUpdatingReschedule.value = false
  }
}
</script>

<style lang="scss" scoped>
.enjoyTime__prefix {
  font-size: 13px;
  line-height: 20px;
}

.divider {
  height: 8px;
}

.disabled {
  pointer-events: none;
}
</style>
